import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type UpdateContractCustomFieldValueApi = ReturnType<typeof getPrivateApi>['updateContractCustomFieldValue'];
type UpdateContractCustomFieldValueOperationRequest = Parameters<UpdateContractCustomFieldValueApi>[0];
type UpdateContractCustomFieldValueResponse = Awaited<ReturnType<UpdateContractCustomFieldValueApi>>;

type UpdateContractCustomFieldValueVariables = {
  customFieldDefinitionId: string;
  updateContractCustomFieldValueRequest: UpdateContractCustomFieldValueOperationRequest['updateContractCustomFieldValueRequest'];
};

export function useUpdateContractCustomFieldValue(
  contractId: string,
  options?: UseMutationOptions<
    UpdateContractCustomFieldValueResponse,
    unknown,
    UpdateContractCustomFieldValueVariables
  >,
) {
  return useMutation(
    ['updateContractCustomFieldValue', contractId],
    (variables: UpdateContractCustomFieldValueVariables) => {
      const api = getPrivateApi();

      return api.updateContractCustomFieldValue({
        contractId,
        customFieldDefinitionId: variables.customFieldDefinitionId,
        updateContractCustomFieldValueRequest: variables.updateContractCustomFieldValueRequest,
      });
    },
    options,
  );
}
